import api from "./api";

// Kept in its own file (rather than added to apiService in api.js) so adding
// care plans touches no existing file. Uses the same axios instance, so auth
// headers and base URL behave exactly like every other call.
const base = (patientId) => `/v1/patients/${patientId}/care-plans`;

export const carePlanService = {
  list: async (patientId) => (await api.get(base(patientId))).data,
  assignableStaff: async (patientId) => (await api.get(`${base(patientId)}/assignable-staff`)).data,
  history: async (patientId, planId) => (await api.get(`${base(patientId)}/${planId}/history`)).data,
  create: async (patientId, body) => (await api.post(base(patientId), body)).data,
  update: async (patientId, planId, body) => (await api.put(`${base(patientId)}/${planId}`, body)).data,
  activate: async (patientId, planId) => (await api.post(`${base(patientId)}/${planId}/activate`)).data,
  archive: async (patientId, planId) => (await api.post(`${base(patientId)}/${planId}/archive`)).data,
  addTask: async (patientId, planId, body) => (await api.post(`${base(patientId)}/${planId}/tasks`, body)).data,
  updateTask: async (patientId, planId, taskId, body) =>
    (await api.patch(`${base(patientId)}/${planId}/tasks/${taskId}`, body)).data,
};

// The backend answers rule violations with {error: "..."} and a precise status.
export const carePlanErrorMessage = (err, fallback) => err?.response?.data?.error || fallback;